import React from "react";
import { Container, Flex, Box, css } from "theme-ui";
import Reveal from "@solid-ui-components/Reveal";
import Divider from "@solid-ui-components/Divider";
import ContentText from "@solid-ui-components/ContentText";
import ContentImages from "@solid-ui-components/ContentImages";
import ContentContainer from "@solid-ui-components/ContentContainer";
import ContentButtons from "@solid-ui-components/ContentButtons";
import WithDefaultContent from "@solid-ui-blocks/WithDefaultContent";

const styles = {
	avatar: {
		bg: `omegaLighter`,
		borderTopColor: `omegaLighter`,
		borderTopWidth: `xl`,
		borderTopStyle: `solid`,
		borderRadius: `lg`,
		boxSizing: `content-box`,
	},
};

const TestimonialsBlock03 = ({
	content: { text, collection, buttons },
	reverse,
}) => (
	<Container>
		<Flex
			sx={{
				alignItems: `flex-start`,
				flexDirection: [
					reverse ? `column-reverse` : `column`,
					null,
					null,
					reverse ? `row-reverse` : `row`,
				],
				mx: [null, null, null, -4],
			}}
		>
			<Box
				sx={{
					flexBasis: `1/2`,
					width: `100%`,
					display: `flex`,
					justifyContent: `center`,
					mx: [null, null, null, 4],
					[reverse ? "mt" : "mb"]: [5, null, null, 0],
				}}
			>
				{collection?.map(({ container, avatar }, index) => (
					<ContentContainer
						content={container}
						variant="cards.paper"
						key={`item-${index}`}
						sx={{
							position: `relative`,
							p: [0, 4],
						}}
					>
						<Flex
							sx={{
								alignItems: `center`,
								position: `relative`,
								flexWrap: `wrap`,
								zIndex: 1,
							}}
						>
							<Box sx={{ width: `100%` }}>
								<ContentImages
									content={{ images: [avatar] }}
									sx={styles.avatar}
									imageEffect="fadeIn"
								/>
							</Box>
						</Flex>
					</ContentContainer>
				))}
			</Box>
			<Box
				sx={{
					flexBasis: `1/2`,
					mx: [null, null, null, 4],
					textAlign: [`center`, null, null, `left`],
				}}
			>
				<Reveal>
					<ContentText content={text} />
					{buttons && (
						<>
							<Divider space={3} />
							<ContentButtons content={buttons} />
						</>
					)}
				</Reveal>
			</Box>
		</Flex>
	</Container>
);

export default WithDefaultContent(TestimonialsBlock03);
